var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.537,
    height: 239.113,
    viewBox: "0 0 168.537 239.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2",
    "data-name": "\\uADF8\\uB8F9 2",
    transform: "translate(-851 -354.887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1",
    transform: "translate(-17 -70)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_1",
    "data-name": "\\uC0AC\\uAC01\\uD615 1",
    transform: "translate(950 595)",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_1",
    "data-name": "\\uB2E4\\uAC01\\uD615 1",
    transform: "translate(996 664) rotate(180)",
    fill: "#545454"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 61.85515975952148 33.5 L 1.144837379455566 33.5 L 31.49999809265137 0.7356995344161987 L 61.85515975952148 33.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.49999809265137 1.471397399902344 L 2.289676666259766 33 L 60.71031951904297 33 L 31.49999809265137 1.471397399902344 M 31.49999809265137 0 L 63 34 L -3.814697265625e-06 34 L 31.49999809265137 0 Z",
    stroke: "none",
    fill: "#545454"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    width: 26,
    height: 8,
    transform: "translate(951 627)",
    fill: "#545454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_3",
    "data-name": "\\uC0AC\\uAC01\\uD615 3",
    transform: "translate(851 428)",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 58,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124,
    height: 57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M1088.865,406.814V338.387h96.682l39.49,44.6v142.64H1088.865V467.751",
    transform: "translate(-209 20)",
    fill: "none",
    stroke: "#545454",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    transform: "translate(861 475)",
    fill: "#fff",
    fontSize: 47,
    fontFamily: "MeiryoUI-Bold, Meiryo UI",
    fontWeight: 700,
    letterSpacing: "0.07em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PDF")), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4",
    "data-name": "\\uC0AC\\uAC01\\uD615 4",
    width: 9,
    height: 12,
    transform: "translate(924 539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 9,
    height: 12,
    transform: "translate(961 539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M1013.63,404.771H973.8v-44.6Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdf_download.432017726e63377dd88e7771747340b7.svg";
export { ForwardRef as ReactComponent };